import React from 'react';
import { createPortal } from 'react-dom';
import OfficialPriceTable from './OfficialPriceTable';
import useBackButtonClose from '../utils/useBackButtonClose';

// OfficialPriceTable(price.png 미러)을 팝업으로 보여주는 모달.
// NavBar '서비스&가격'에서 비-홈 페이지일 때 사용.
// 홈에서는 #pricing 섹션 스크롤이 우선이라 이 모달 안 띄움.

const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.75)',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  // zIndex 200 < NavBar 1000; paddingTop 84 = nav 64 + gutter 20
  zIndex: 200, padding: '84px 20px 20px',
};

const cardStyle = {
  background: 'var(--surface)',
  borderRadius: 'var(--radius)',
  border: '1px solid var(--border)',
  padding: 24,
  maxWidth: 920, width: '100%',
  maxHeight: '85vh', overflowY: 'auto',
};

export default function OfficialPriceModal({ open, onClose }) {
  // 모바일 뒤로가기로 모달만 닫기(SPA 이탈 방지).
  useBackButtonClose(open, onClose);

  if (!open) return null;

  return createPortal(
    <div style={overlayStyle} onClick={onClose}>
      <div className="card" style={cardStyle} onClick={e => e.stopPropagation()}>
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', marginBottom: 16,
        }}>
          <h2 style={{ margin: 0, fontSize: '1.3rem' }}>요금표</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="닫기"
            style={{
              background: 'none', border: 'none',
              fontSize: '1.6rem', lineHeight: 1,
              color: 'var(--text-muted)', cursor: 'pointer', padding: 4,
            }}
          >
            ×
          </button>
        </div>

        <OfficialPriceTable />

        <div style={{
          display: 'flex', justifyContent: 'center',
          marginTop: 20,
        }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onClose}
            style={{ padding: '10px 32px' }}
          >
            닫기
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
